import { Svg, type SvgProps } from './Svg.tsx';

export const Hill: React.FC<SvgProps> = (props) => (
  <Svg
    width="710"
    height="101"
    viewBox="0 0 710 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.118652 100.871L286.32 100.872H709.119V43.8326C709.119 36.8769 703.311 31.3672 696.371 31.8212C656.608 34.4222 532.586 42.07 450 42C361.712 41.9251 326 27.5 234 23.5C198.142 21.9409 191.992 20.8446 167.279 17C135.298 12.0246 84.6013 11.2461 84.6013 11.2461L58.1903 9.87307L61.7793 0C61.7793 0 43.6627 5.84241 31.7793 8.5C19.5 11.2461 7.10419 11.2461 2.7793 23.5C-0.220703 32 0.118652 50.2896 0.118652 56.9594V100.871Z"
      fill="url(#paint0_linear_7440_10561)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7440_10561"
        x1="-7.00009"
        y1="147.5"
        x2="-14.2456"
        y2="18.4702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D66313" />
        <stop offset="0.81" stopColor="#499D69" />
      </linearGradient>
    </defs>
  </Svg>
);
